import React from "react";
import { Route, Redirect } from "react-router-dom";
/**
 *  If the user is authenticated render the passed in component.
 *  else use the Redirect React Router v4 component to redirect the login page.
 *  We also pass in the current path to the login page (redirect in the querystring).
 *  We will use this later to redirect us back after the user logs in.
 */
export default ({ component: C, props: cProps, ...rest }) =>
  <Route
    {...rest}
    render={props =>
      cProps.isAuthenticated
        ? <C {...props} {...cProps} />
        : <Redirect
            to={`/login?redirect=${props.location.pathname}${props.location
              .search}`}
          />}
  />;



// WEBPACK FOOTER //
// ./src/components/AuthenticatedRoute.js